import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-impressum',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent
    ],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.scss'
})
export class ImpressumComponent {

}
